/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

 /**
 * ----------------------------------------------------------------------------------------------
 * Accordion component
 * ----------------------------------------------------------------------------------------------
 */


  $( function() {
    $( "#accordion" ).accordion({
        collapsible: true,
      	heightStyle: "content"
    });
} );

/**
 * ----------------------------------------------------------------------------------------------
 * Gallery component
 * ----------------------------------------------------------------------------------------------
 */


$(document).ready(function() {

	if ($(".product__slider-main").length) {
		var $slider = $(".product__slider-main")
		  .on("init", function (slick) {
			$(".product__slider-main").fadeIn(1000);
			clrbx();
		  })
		  .slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: true,
			lazyLoad: "ondemand",
			autoplaySpeed: 3000,
            accessibility: true,
			asNavFor: ".product__slider-thmb",
			prevArrow:"<button type='button' class='slick-prev pull-left'><img src='//mactools-staging.myshopify.com/cdn/shop/t/3/assets/arrow_forward_btn_small.png?v=76334304567617899891619194433'></button>",
			nextArrow:"<button type='button' class='slick-next pull-right'><img src='//mactools-staging.myshopify.com/cdn/shop/t/3/assets/arrow_back_btn_small.png?v=8590059958480484421619194433'></button>",

			responsive: [
				{
					breakpoint: 768,
					settings: {
						arrows: false,
					}
				}
			]

		  });

		var thumbnailsSlider = $(".product__slider-thmb")
		  .on("init", function (slick) {
			$(".product__slider-thmb").fadeIn(1000);
		  })
		  .slick({
			slidesToShow: 9,
			slidesToScroll: 1,
			arrows: false,
			lazyLoad: "ondemand",
			asNavFor: ".product__slider-main",
			dots: false,
			centerMode: false,
			focusOnSelect: true,
            accessibility: true,
			prevArrow:"<button type='button' class='slick-prev pull-left'><img src='/arrow_forward_btn.png'></button>",
			nextArrow:"<button type='button' class='slick-next pull-right'><img src='/arrow_back_btn.png'></button>",
			responsive: [
				{
					breakpoint: 1024,
					settings: {
						slidesToShow: 8,
						slidesToScroll: 1,
					}
				},
				{
					breakpoint: 640,
					settings: {
						slidesToShow: 4,
						slidesToScroll: 1,
					}
				},
				{
					breakpoint: 480,
					settings: {
						slidesToShow: 4,
						slidesToScroll: 1,
					}
				}
			]
		  });

		//remove active class from all thumbnail slides
		$(".product__slider-thmb .slick-slide").removeClass("slick-active");

		//set active class to first thumbnail slides
		$(".product__slider-thmb .slick-slide").eq(0).addClass("slick-active");

		// On before slide change match active thumbnail to current slide
		$(".product__slider-main").on(
		  "beforeChange",
		  function (event, slick, currentSlide, nextSlide) {
			var mySlideNumber = nextSlide;
			$(".product__slider-thmb .slick-slide").removeClass("slick-active");
			$(".product__slider-thmb .slick-slide")
			  .eq(mySlideNumber)
			  .addClass("slick-active");
		  }
		);

		// init slider
		//require(['js-sliderWithProgressbar'], function(slider) {
		$(".product__slider-main").each(function () {
		  //var sldr = new slider($(this), options, sliderOptions, previewSliderOptions);
		});

		var options = {
		  progressbarSelector: ".bJS_progressbar",
		  slideSelector: ".bJS_slider",
		  previewSlideSelector: ".bJS_previewSlider",
		  progressInterval: "",
		  onCustomProgressbar: function ($slide, $progressbar) {}
		};

		var sliderOptions = {
		  slidesToShow: 1,
		  slidesToScroll: 1,
		  arrows: false,
		  fade: true,
		  autoplay: true
		};

		var previewSliderOptions = {
		  slidesToShow: 3,
		  slidesToScroll: 1,
		  dots: false,
		  focusOnSelect: true,
		  centerMode: true
		};

		// Colorbox
		function clrbx() {
		  $(".product__slider-main .slick-slide").each(function () {});
		}
	  }

});

/**
 * ----------------------------------------------------------------------------------------------
 * Student/staff form state and school dropdown
 * ----------------------------------------------------------------------------------------------
 */

var countryValues =[];
var countryState = {};
var stateSchools = {};

$(".register-form .address1").hide().prop('required',false);
$(".register-form .address2").hide().prop('required',false);
$(".register-form .addcountry").hide().prop('required',false);
$(".register-form .addprovince").hide().prop('required',false);
$(".register-form .city").hide().prop('required',false);
$(".register-form .zipcode").hide().prop('required',false);
$(".register-form .states").hide().prop('required',false);
$(".register-form .schools").hide().prop('required',false);
$(".register-form .course").hide().prop('required',false);
$(".register-form .school-name").hide();
$(".register-form .school-name input").prop('required',false);
$(".register-form .customer__address-field").hide();

$(".customer-registration input").click(function(e) {
	$(this).parents("form").find(".course").hide();
	$(this).parents("form").find(".dob").hide();
	$(this).parents("form").find(".dob input").prop('required',false);

    $(".register-form .address1").hide().prop('required',false);
    $(".register-form .address2").hide().prop('required',false);
  	$(".register-form .addcountry").hide().prop('required',false);
    $(".register-form .addprovince").hide().prop('required',false);
    $(".register-form .city").hide().prop('required',false);
    $(".register-form .zipcode").hide().prop('required',false);
    $(".register-form .states").hide().prop('required',false);
    $(".register-form .schools").hide().prop('required',false);
    $(".register-form .course").hide().prop('required',false);
	  $(".register-form .school-name").hide();
	  $(".register-form .school-name input").prop('required',false);
    $(".register-form .customer__address-field").hide();

	if(($(this).val() === 'UserType:STPStudent') || ($(this).val() === 'UserType:STPStaff')){
		$(this).parents("form").find('.states').show();
		$(this).parents("form").find('.schools').show();
    $(this).parents("form").find("input[type='tel']").prop('required',true);

        $(this).parents("form").find(".address1").show().prop('required',true);
        $(this).parents("form").find(".address2").show().prop('required',false);
      	$(this).parents("form").find(".addcountry").show().prop('required',true);
        $(this).parents("form").find(".addprovince").show().prop('required',true);
        $(this).parents("form").find(".city").show().prop('required',true);
        $(this).parents("form").find(".zipcode").show().prop('required',true);
        $(this).parents("form").find(".states").show().prop('required',true);
        $(this).parents("form").find(".schools").show().prop('required',true);
        $(this).parents("form").find(".course").show().prop('required',true);
        $(this).parents("form").find(".customer__address-field").show();

		var target = $(this).parents("form").find('#states');
		target.empty();
		$('<option id="' + "Please Select" + '" value="' + "" + '">' + "Select School State" + '</option>').appendTo(target);
		var states = countryState['USM'];
		if (states != undefined) {
			states.sort();
			for(var i = 0; i < states.length; i++) {
				$('<option id="' + states[i] + '" value="' + states[i] + '">' + states[i] + '</option>').appendTo(target);
			}
		}
        if($(this).val() === 'UserType:STPStudent'){
          $(this).parents("form").find(".course").show();
          $(this).parents("form").find(".dob").show();
		  $(this).parents("form").find(".dob input").prop('required',true);
        } else {
          $(this).parents("form").find(".course").show();
          $(this).parents("form").find(".dob").hide();
		  $(this).parents("form").find(".dob input").prop('required',false);
        }
	} else if($(this).val() === 'National Partner') {
		$(this).parents("form").find('.states').hide();
		$(this).parents("form").find('.schools').hide();
      	$(this).parents("form").find('.states option').remove();
		$(this).parents("form").find('.schools option').remove();
	} else {
		$(this).parents("form").find('.states').hide();
		$(this).parents("form").find('.schools').hide();
      	$(this).parents("form").find('.states option').remove();
		$(this).parents("form").find('.schools option').remove();
    $(this).parents("form").find("input[type='tel']").prop('required',false);

	}
});

$('#states').on('change', function () {
	var target = $(this).parents(".register-form").find('#schools');
	target.empty();
	$('<option id="' + "Please Select" + '" value="' + "" + '">' + "Select School" + '</option>').appendTo(target);
	var schools = stateSchools[$(this).val()];
	if (states != undefined) {
		schools.sort();
		for(var i = 0; i < schools.length; i++) {
			$('<option id="' + schools[i] + '" value="' + schools[i] + '">' + schools[i] + '</option>').appendTo(target);
		}
	}
});
$('.statespage').on('change', function () {
	var target = $(this).parents(".register-form").find('#schools');
	target.empty();
	$('<option id="' + "Please Select" + '" value="' + "" + '">' + "Select School" + '</option>').appendTo(target);
	var schools = stateSchools[$(this).val()];
	if (states != undefined) {
		schools.sort();
		for(var i = 0; i < schools.length; i++) {
			$('<option id="' + schools[i] + '" value="' + schools[i] + '">' + schools[i] + '</option>').appendTo(target);
		}
      	$(target).append($('<option>', {
            value: 'Other',
            text: 'Other'
        }));
	}
});

$(window).on("load", function(){
  var stud_weburl = document.getElementById("student-webdav-url");
  if(stud_weburl) {
    $('#create_customer')[0].reset();
    d3.csv(document.getElementById("student-webdav-url").getAttribute("data-value"), function(data) {
      if(!countryValues.includes(data.DivisionCode)) {
        countryValues.push(data.DivisionCode);
      }
      if (data.DivisionCode in countryState){
        if (!countryState[data.DivisionCode].includes(data.ShipToStateCode)){
          countryState[data.DivisionCode].push(data.ShipToStateCode);
        }
      }else{
        countryState[data.DivisionCode] = [data.ShipToStateCode];
      }
      if (data.ShipToStateCode in stateSchools){
        if (!stateSchools[data.ShipToStateCode].includes(data.Name)){
          stateSchools[data.ShipToStateCode].push(data.Name);
        }
      }else{
        stateSchools[data.ShipToStateCode] = [data.Name];
      }
    });
  }
});

$(".email-confirm").blur(function () {
  	var emailval = $(this).parents("form").find('.create-email').val();
	if ( $(this).val() === emailval) {
      $(this).parent().find(".match-msg").hide();
    } else {
      $(this).parent().find(".match-msg").show();
    }
});
$(".password-confirm").blur(function () {
  var passwordval = $(this).parents("form").find('.create-password').val();
  	if ( $(this).val() === passwordval) {
      $(this).parent().find(".match-msg").hide();
    } else {
      $(this).parent().find(".match-msg").show();
    }
});

$(".create-password").on('input',function () {
  var p = $(this).val();
  var errors = [];
  var emailval = $(this).parents("form").find('.create-email').val();
  
  if (p.length <= 0) {
    errors.push("Password can contain any character.");
  }
  if (p.search(/^[^0-9]/) < 0) {
    errors.push("Password must not start with a number.");
  }
  if (p.length < 8 || p.length > 20) {
    errors.push("Password length must be between 8 to 20 characters."); 
  }
  if (p.search(/(?=.*[A-Z])/) < 0) {
    errors.push("Password must contain at least one uppercase alphabet."); 
  }
  if (p.search(/(?=.*[a-z])/) < 0) {
    errors.push("Password must contain at least one lowercase alphabet."); 
  }
  if (p.search(/[0-9]/) < 0) {
    errors.push("Password must contain at least one number."); 
  }
  if (p === emailval){
    errors.push("Password cannot be the same as your username."); 
  }
  if (errors.length > 0) {
    $(this).parent().find(".match-msg").html(errors.join("<br/>"));
    $(this).parent().find(".match-msg").show();
    $(this).addClass('invalid');
    $(".reset-password-wrapper__form .form__submit, .register-form .form__submit").attr('disabled', 'disabled');
  } else {
    $(this).parent().find(".match-msg").hide();
    $(this).removeClass('invalid');
    $(".reset-password-wrapper__form .form__submit, .register-form .form__submit").removeAttr('disabled');

  }
});

$(".schools").on('change', function () {
  $(this).parent().next(".school-name").hide();
  $(this).parent().next(".school-name").find("input").removeAttr('required');
  if($(this).find('option:selected').val() == "Other") {
    $(this).parent().next(".school-name").show();
    $(this).parent().next(".school-name").find("input").attr('required', 'required');
  }
});

function addstatefn(thisObj) {
  thisObj.parents(".register-form").find('.addprovince').empty();
  if(thisObj.find('option:selected').val() == "CA") {
    var selectValues = {
      "": "Select State",
      "AB": "Alberta",
      "BC": "British Columbia",
      "MB": "Manitoba",
      "NB": "New Brunswick",
      "NL": "Newfoundland and Labrador",
      "NT": "Northwest Territories",
      "NS": "Nova Scotia",
      "NU": "Nunavut",
      "ON": "Ontario",
      "PE": "Prince Edward Island",
      "QC": "Quebec",
      "SK": "Saskatchewan",
      "YT": "Yukon Territory"
    };
  }else {
    var selectValues = {
      "": "Select State",
      "AL": "Alabama",
      "AK": "Alaska",
      "AZ": "Arizona",
      "AR": "Arkansas",
      "CA": "California",
      "CO": "Colorado",
      "CT": "Connecticut",
      "DE": "Delaware",
      "FL": "Florida",
      "GA": "Georgia",
      "HI": "Hawaii",
      "ID": "Idaho",
      "IL": "Illinois",
      "IN": "Indiana",
      "IA": "Iowa",
      "KS": "Kansas",
      "KY": "Kentucky",
      "LA": "Louisiana",
      "ME": "Maine",
      "MD": "Maryland",
      "MA": "Massachusetts",
      "MI": "Michigan",
      "MN": "Minnesota",
      "MS": "Mississippi",
      "MO": "Missouri",
      "MT": "Montana",
      "NE": "Nebraska",
      "NV": "Nevada",
      "NH": "New Hampshire",
      "NJ": "New Jersey",
      "NM": "New Mexico",
      "NY": "New York",
      "NC": "North Carolina",
      "ND": "North Dakota",
      "OH": "Ohio",
      "OK": "Oklahoma",
      "OR": "Oregon",
      "PA": "Pennsylvania",
      "PR": "Puerto Rico",
      "RI": "Rhode Island",
      "SC": "South Carolina",
      "SD": "South Dakota",
      "TN": "Tennessee",
      "TX": "Texas",
      "UT": "Utah",
      "VT": "Vermont",
      "VA": "Virginia",
      "WA": "Washington",
      "DC": "Washington DC",
      "WV": "West Virginia",
      "WI": "Wisconsin",
      "WY": "Wyoming"
    };
  }
  var $addprovince = thisObj.parents(".register-form").find('.addprovince');
  $.each(selectValues, function(key, value) {
    var $option = $("<option/>", {
      value: key,
      text: value
    });
    $addprovince.append($option);
  });
};

$(".addcountry").on('change', function () {
  addstatefn($(this));
});
$(".addcountry").each(function () {
  addstatefn($(this));
});

$(".addprovince").on('change', function () {
  var provincecodeval = $(this).find("option:selected").val();
  if(provincecodeval != "select state") {
  $(this).find(".select-state").hide();
  }else {
  $(this).find(".select-state").show();
  }
});

$('form.register-form').submit(function (e) {
  
  if ($(this).find('.invalid')){
    $(this).find('.invalid').val('');
  	e.preventDefault();
  }
  var jsonObj = [];
  var state = $(this).find('#states :selected').text();
  var school = $(this).find('#schools :selected').text().trim();
  var schoolother = $(this).find('.school-name input').val();
  var user = $(this).find('.customer-registration input:checked').val();
  var phone = $(this).find('.phonenum').val();
  var dob = $(this).find('#_dateto').val();
  var dobr = $(this).find('#_datetor').val();
  var course = $(this).find(".course :selected").text();
  var city = $(this).find(".city").val();
  var address1 = $(this).find(".address1").val();
  var address2 = $(this).find(".address2").val();
  var countrycode = $(this).find(".addcountry :selected").val();
  var provincecode = $(this).find(".addprovince :selected").val();
  var zipcode = $(this).find(".zipcode").val();
  var vc = $(this).find('input#vc').val();
  var otp = ",otp:"+$(this).find('input#pc').val();

  item = {}
  item ['Account'] = user;
  if(user === "UserType:STPStudent" || user === "UserType:STPStaff" ) {
  if(state) {
  item ['State'] = state;
  }
  if(school != "Other") {
  item ['School'] = school;
  }else {
  item ['School'] = schoolother;
  }
  if(course != "Select course") {
  item ['Course'] = course;
  }
  item ['city'] = city;
  item ['address1'] = address1;
  item ['address2'] = address2;
  item ['country_code'] = countrycode;
  if($('.addprovince').is(':visible')){
  if(provincecode != "select state") {
  $(this).find(".select-state").hide();
  item ['province_code'] = provincecode;
  }else if(provincecode == "select state") {
  $(this).find(".select-state").show();
  return false;
  }
  }
  item ['zip'] = zipcode;
  if(dob) {
  item ['DOB'] = dob;
  }
  if(dobr) {
  item ['DOB'] = dobr;
  }
  }
  if($(this).find('input.privacyPolicyCheckBox').is(':checked')) {
  item ['Privacy Policy Consent'] = "Accepted";
  } else {
  item ['Privacy Policy Consent'] = "Rejected";
  }
  if($(this).find('input#newsletterbox').is(':checked')) {
  item ['Email Consent'] = "Accepted";
  } else {
  item ['Email Consent'] = "Rejected";
  }
  item ['Phone'] = phone;
  jsonObj.push(item);
  var jsonString = JSON.stringify(jsonObj);
  jsonString = jsonString.replace(/\\n/g, '');
  $(this).find("#customedetails").val(jsonString);
  if(user === "UserType:STPStudent" || user === "UserType:STPStaff" ) {
  $(this).find("#custometags").val(user+vc+", Pending"+otp);
  }else {
  $(this).find("#custometags").val(user+vc+otp);
  }
});

/**
 * ----------------------------------------------------------------------------------------------
 * Prevent tabbing out of modal dialog
 * ----------------------------------------------------------------------------------------------
 */
$(document).on('keydown', function(e) {
    var target = e.target;
    var shiftPressed = e.shiftKey;
    if (e.keyCode == 9) {
        if ($(target).parents('[role=dialog]').length) {
            var borderElem = shiftPressed ?
                                $(target).closest('[role=dialog]').find('input:visible,select:visible,button:visible,textarea:visible').first()
                             :
                                $(target).closest('[role=dialog]').find('input:visible,select:visible,button:visible,textarea:visible').last();
            if ($(borderElem).length) {
                if ($(target).is($(borderElem))) {
                    return false;
                } else {
                    return true;
                }
            }
        }
    }
    return true;
});
$(document).ready(function() {
  setTimeout(function () {
    var slidemainwdth = $(".product__slider-main a.slide").width();
    var slidemainhght = $(".product__slider-main a.slide").height();
    $(".product__slider-main").find("iframe").width(slidemainwdth).height(slidemainhght);
  }, 300);
});


$(document).ready(function() {

  $(".address-state").each( function () {

    $(this).find("option[value='American Samoa']").remove();
    $(this).find("option[value='Armed Forces Americas']").remove();
    $(this).find("option[value='Armed Forces Europe']").remove();
    $(this).find("option[value='Armed Forces Pacific']").remove();
    $(this).find("option[value='District of Columbia']").remove();
    $(this).find("option[value='Federated States of Micronesia']").remove();
    $(this).find("option[value='Guam']").remove();
    $(this).find("option[value='Marshall Islands']").remove();
    $(this).find("option[value='Northern Mariana Islands']").remove();
    $(this).find("option[value='Palau']").remove();
    $(this).find("option[value='Virgin Islands']").remove();


    if ($(this).find("option[value='select-state']").length > 0) {
    return false;
    }else {
    if($(this).parents("#address_form_new").length) {
    $(this).prepend("<option value='select-state' selected='selected'>Select state</option>");
    }else {
    $(this).prepend("<option value='select-state'>Select state</option>");
    }
    }
    });
    $(".form__submit").click(function () {
    if($(this).parent().find('.address-state option:selected').val() == "select-state") {
    $(this).parent().find(".address-error-state").show();
    return false;
    }else {
    $(this).parent().find(".address-error-state").hide();
    }
    });
    $('.address-state').on('change', function () {
    if($(this).find('option:selected').val() == "select-state") {
    $(this).parent().find(".address-error-state").show();
    }else {
    $(this).parent().find(".address-error-state").hide();
    }
  });

  $('input[name="customer[first_name]"]').on('keypress', function (event) {
    var regex = new RegExp("^[A-Za-z0-9? ]+$");
    var key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
    if (!regex.test(key)) {
    event.preventDefault();
    return false;
    }
  });
  $('input[name="customer[last_name]"]').on('keypress', function (event) {
    var regex = new RegExp("^[A-Za-z0-9? ]+$");
    var key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
    if (!regex.test(key)) {
    event.preventDefault();
    return false;
    }
  });
  $('input[name="address[first_name]"]').on('keypress', function (event) {
    var regex = new RegExp("^[A-Za-z0-9? ]+$");
    var key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
    if (!regex.test(key)) {
    event.preventDefault();
    return false;
    }
  });
  $('input[name="address[last_name]"]').on('keypress', function (event) {
    var regex = new RegExp("^[A-Za-z0-9? ]+$");
    var key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
    if (!regex.test(key)) {
    event.preventDefault();
    return false;
    }
  });

  $('input[type="tel"]').each(function () {
    var telval = $(this).val();
	telval = telval.replace('+1', '');
    telval = telval.replace(/\D/g,"");
    if(telval) {
      if ($('.view-profile-wrap').length > 0) {
        $(this).parents("#customerProfileForm").find('.phonenum').val(telval);
      }else if ($(".modal__dialog").length > 0) {
        $(this).parent().find('.phonenum').val(telval);
      }else {
        $(this).parents(".register-form").find(".phonenum").val(telval);
      }
      $(this).val('('+telval[0]+telval[1]+telval[2]+') '+telval[3]+telval[4]+telval[5]+'-'+telval[6]+telval[7]+telval[8]+telval[9]);
    }
  });

  var telvalpro = $('.profile-tel').text();
  $('.profile-tel').text('('+telvalpro[0]+telvalpro[1]+telvalpro[2]+') '+telvalpro[3]+telvalpro[4]+telvalpro[5]+'-'+telvalpro[6]+telvalpro[7]+telvalpro[8]+telvalpro[9]);

  $('#play-video').on('click', function(ev) {
    var iframe_default_src = $('#youtube_video').attr('default-data-src');
    $("#youtube_video").attr('data-src', iframe_default_src);
    //$("#youtube_video")[0].src += "?autoplay=1";
    //$('#youtube_video')[0].click();
    //$('#youtube_video').trigger('click');
    ev.preventDefault();
  });

  // change date format
  if ($(".profile_dob")[0]){
    var profile_dob = document.getElementsByClassName("profile_dob")[0].value;
    var dob_iso = profile_dob.split('/');
    document.getElementsByClassName('profile_dateto')[0].value = dob_iso[2]+"-"+dob_iso[0]+"-"+dob_iso[1]+"T14:00:00.000Z";
  }

});

$(".nav-bar__link.link").keyup(function (e) {
  $(".nav-bar__link.link").attr("aria-expanded", "false");
  $(this).find(".icon.icon--nav-triangle").addClass("display-none");
  if (e.keyCode == 9 || e.keyCode == 37 || e.keyCode == 39) {
    $(".nav-dropdown").hide();
  }
  if (e.keyCode == 40) {
    $(this).attr("aria-expanded", "true");
    $(this).find(".icon.icon--nav-triangle").removeClass("display-none");
    $(".nav-dropdown").show();
  }
});

$(".nav-dropdown__link.link").keyup(function (e) {
  if (e.keyCode == 13) {
    let url = $(this).prop("href");
    location.replace(url);
  }
  if (e.keyCode == 38 || e.keyCode == 40) {
    $(this).siblings(".nav-dropdown").hide();
  }
  if (e.keyCode == 39) {
    $(this).siblings(".nav-dropdown").show();
  }
});

$(".search-bar__input").keyup(function (e) {
  if (e.keyCode == 9) {
    const val = $(this).val();
    if(val.length == 0){
      $(this).blur()
    }
  }
});


/* edit profile js */
$(".edit-field").hide();
$("#save-profile").hide();
$(".save-field").each(function () {
  var valinput = $(this).html();
  if(!valinput) {
    $(this).parent().hide();
  };
});
$("#edit-profile").click(function () {
  $(this).hide();
  $("#save-profile").show();
  $(".save-field").hide();
  $(".edit-field").show();
  $(".save-field").parent().show();
});
$("#save-profile").click(function () {
  $(this).hide();
  $("#edit-profile").show();
  $(".save-field").show();
  $(".edit-field").hide();
  $(".save-field").each(function () {
    var valinput = $(this).html();
    if(!valinput) {
      $(this).parent().hide();
    };
  });
  var jsonObjupdate = [];
        var firstname    = $(this).parent().find('.firstname').val();
        var lastname   = $(this).parent().find('.lastname').val();
  		var phone   = $(this).parent().find('.phonenum').val();
		var dob    = $(this).parent().find('.dob').val();
  		var country   = $(this).parent().find('.country').val();
        item = {}
        	item ['first_name']     = firstname;
          	item ['last_name']        = lastname;
  			item ['phone']     = phone;
          	item ['dob']        = dob;
  			item ['country']     = country;
        jsonObjupdate.push(item);
        var jsonStringupdate = JSON.stringify(jsonObjupdate);
  console.log(jsonStringupdate);
	$(this).parent().find("#customeupdatedetails").val(jsonStringupdate);
});

function checkForInput(element) {
  if ($(element).val().length > 0) {
    $(element).addClass('is-filled');
  } else {
    $(element).removeClass('is-filled');
  }
}

$("#dob").datepicker({
  altField: "#_dateto",
  altFormat: "yy-mm-dd'T'14:00:00.000Z",
  dateFormat: 'mm/dd/yy',
  maxDate: new Date(),
  changeMonth: true,
  changeYear: true,
  yearRange: "-100:+0"
 }).on("change", function() {
    checkForInput(this);
    var curDate = $(this).datepicker("getDate");
    var maxDate = new Date();
    maxDate.setDate(maxDate.getDate() + 1); // add one day
    maxDate.setHours(0, 0, 0, 0); // clear time portion for correct results
    if (curDate > maxDate) {
        alert("Invalid date");
        $(this).datepicker("setDate", maxDate);
    }
});

$("#dob_reg").datepicker({
  altField: "#_datetor",
  altFormat: "yy-mm-dd'T'14:00:00.000Z",
  dateFormat: 'mm/dd/yy',
  maxDate: new Date(),
  changeMonth: true,
  changeYear: true,
  yearRange: "-100:+0"
}).on("change", function() {
    checkForInput(this);
    var curDate = $(this).datepicker("getDate");
    var maxDate = new Date();
    maxDate.setDate(maxDate.getDate() + 1); // add one day
    maxDate.setHours(0, 0, 0, 0); // clear time portion for correct results
    if (curDate > maxDate) {
        alert("Invalid date");
        $(this).datepicker("setDate", maxDate);
    }
  });
  $("#dob_cus").datepicker({
    altField: "#_dateto",
    altFormat: "yy-mm-dd'T'14:00:00.000Z",
    dateFormat: 'mm/dd/yy',
  maxDate: new Date(),
  changeMonth: true,
  changeYear: true,
  yearRange: "-100:+0",
  onSelect: function(){
    checkForInput(this);
    $("#account-popover").attr("aria-hidden" , "false");
  }
}).on("change", function(e) {
    var curDate = $(this).datepicker("getDate");
    var maxDate = new Date();
    maxDate.setDate(maxDate.getDate() + 1); // add one day
    maxDate.setHours(0, 0, 0, 0);           // clear time portion for correct results
    if (curDate > maxDate) {
        alert("Invalid date");
        $(this).datepicker("setDate", maxDate);
    }
});
/* edit profile js end */

$(".ui-datepicker").on("click", function () {
  if($("#account-popover").attr("aria-hidden")=="false"){
    $("#account-popover").attr("aria-hidden" , "false");
    return false;
  }
});
$(document).on("click", function(e) {
    var elem = $(e.target);
    if(!elem.hasClass("hasDatepicker") &&
        !elem.hasClass("ui-datepicker") &&
        !elem.hasClass("ui-icon") &&
        !elem.hasClass("ui-datepicker-next") &&
        !elem.hasClass("ui-datepicker-prev") &&
        !$(elem).parents(".ui-datepicker").length){
            $('.hasDatepicker').datepicker('hide');
    }
});
$(".register_popup_wrapr").scroll(function () {
  $("#dob_cus").datepicker('hide');
});
$(".collection__clear-filter").on("click",function() {

  	//$('.checkbox').removeAttr('data-action');

     //$('.checkbox.is-selected').trigger('click');
     //$('input[type="checkbox"]:checked').removeClass('is-selected');
     //$('input[type="checkbox"]:checked').prop('checked',false);
    // $('input[type="checkbox"]:checked').closest('.checkbox-wrapper').trigger('click');
     var styles = '<style>.search.product-item,.collection.product-item{display:block!important;}</style>';
     $('.collection__dynamic-css').html(styles);

});

$("#shopify-section-wish-list-template").on("change", ":checkbox", function() {
  if($(this).is(":checked")) {
    $(this).closest('tr').addClass('active');
  } else {
    $(this).closest('tr').removeClass('active');
  }
});
$("#shopify-section-wish-list-template").on("click", "#bulkMoveToCart", function() {
	localStorage.setItem("addedToCart","1");
});
if(localStorage.getItem("addedToCart")){
  var addedToCart = localStorage.getItem("addedToCart");
  if(addedToCart == "1"){
  setTimeout(function(){
  document.documentElement.dispatchEvent(new CustomEvent('product:added', {
  bubbles: true,
  detail: {
      quantity: 1
    }
  }));
  }, 500);
  }
  localStorage.removeItem("addedToCart");
}

$('input[type="tel"]').bind('paste', function(e) {
  var inpval = e.originalEvent.clipboardData.getData('Text');
  var inpvallen = inpval.length;
  if (inpvallen == 10 && $.isNumeric(inpval)) {
    $(this).val("("+inpval[0]+inpval[1]+inpval[2]+") "+inpval[3]+inpval[4]+inpval[5]+"-"+inpval[6]+inpval[7]+inpval[8]+inpval[9]);
  } else if (inpvallen == 14 && inpval[0] == "(" && inpval[4] == ")" && inpval[5] == " " && inpval[9] == "-") {
  	return true;
  } else {
  	return false;
  }
});

$('input[type="tel"]').keyup(function(e) {
  var curchr = this.value.length;
  var curval = $(this).val();
  if (curchr == 3 && curval[0] != "(") {
    if( e.keyCode!=8 ){
  $(this).val("(" + curval + ")" + " ");
  }
} else if (curchr == 4 && curval[0] == "(") {
  if( e.keyCode!=8 ){
        $(this).val(curval + ")" + " ");
  }
} else if (curchr == 5 && curval[4] != ")") {
  if( e.keyCode!=8 ){
        $(this).val(curval[0]+curval[1]+curval[2]+curval[3]+ ")" + " "+curval[4]);
  }
} else if (curchr == 6 && curval[5] != " ") {
  if( e.keyCode!=8 ){
        $(this).val(curval[0]+curval[1]+curval[2]+curval[3]+curval[4]+ " " +curval[5]);
  }
} else if (curchr == 10 && curval[9] != "-") {
  if( e.keyCode!=8 ){
    $(this).val(curval[0]+curval[1]+curval[2]+curval[3]+curval[4]+curval[5]+curval[6]+curval[7]+curval[8]+ "-" +curval[9]);
  }
}
  if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105) && e.keyCode !=8 ) {
  e.preventDefault();
  }
  var putval = $(this).val().replace(/\D+/g, "");
  var putvaldefault = $(this).val();
  $(this).parents(".register-form").find(".phonenum").val(putval);
  if ($('.view-profile-wrap').length > 0) {
  $(this).parents("#customerProfileForm").find('.phonenum').val(putval);
  }else if ($(".modal__dialog").length > 0) {
  $(this).parent().find('.phonenum').val(putvaldefault);
  }else {
  $(this).parents(".register-form").find(".phonenum").val(putval);
  }
});
$(document).on('click', '.ui-datepicker-header select' , function() {
  $("#account-popover").attr("aria-hidden" , "false");
});
$('input[type="tel"]').keypress(function(event){
  if(event.which != 8 && isNaN(String.fromCharCode(event.which))){
  event.preventDefault();
  }
  if(event.which === 32){
  event.preventDefault();
  }
});

$('input[name="address[zip]"]').each(function () {
	$(this).attr("maxlength", "9");
});
$('input[name="address[zip]"]').on('keypress', function () {
  var regex = new RegExp("^[A-Za-z0-9?]+$");
  var key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
  if (!regex.test(key)) {
    event.preventDefault();
    return false;
  }
});
$('input[name="customer[zipcode]"]').on('keypress', function () {
  var regex = new RegExp("^[A-Za-z0-9?]+$");
  var key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
  if (!regex.test(key)) {
    event.preventDefault();
    return false;
  }
});

$(function() {
  $('a[href$="logout"]').on('click',function(e){
    e.preventDefault();
    $.ajax({
      type: "POST",
      url: '/cart/clear.js',
      success: function(){
         window.location.href =  '/account/logout'
      },
      dataType: 'json'
    });
  })
});

$(document).ready(function(){
	$('#force-address').trigger('click');
});

$(function() {

  const endpointLink  = 'https://macshopify-us-staging.sbd-nonprod.com/api';
  const token = '893ca8ee-63cf-4ad8-afa7-d063fec127f6';

  $('input[name="customer[zipcode]"],input[name="address[zip]"]').on('input', function (event) {
    $('.zipcode-error').remove();
    if($(this).val().length >= 5){
      $.ajax({
        type: "GET",
        url: endpointLink+'/zipCodeLookup?zipCode='+$(this).val(),
        success: function(response){
          //console.log("zip",response);
          if($.trim(response.data)){
            let cityArray = [];
            let stateArray = [];

            $.each(response.data , function(index, val) {
              //console.log(index, val);
              cityArray.push(response.data[index]['city']);
              stateArray.push(response.data[index]['state']);
            });

            function onlyUnique(value, index, self) {
              return self.indexOf(value) === index;
            }

            let uniqueCity = cityArray.filter(onlyUnique);
            let uniqueState = stateArray.filter(onlyUnique);

            //console.log("uniqueCity",uniqueCity);
            //console.log("uniqueState",uniqueState);

            let cityHtml = [];

            $('.customer__address-field .city').replaceWith('<div class="addcityswrap select-wrapper select-wrapper--primary is-filled"><svg focusable="false" class="icon icon--arrow-bottom" viewBox="0 0 12 8" role="graphics-symbol"><path stroke="currentColor" stroke-width="2" d="M10 2L6 6 2 2" fill="none" stroke-linecap="square"></path></svg><select id="city" class="city citydropdown form__field form__field--text" name="customer[city]" style="display: inline-block;" required><option value="">Select City</option></select></div>');

            $('.my_address_city').replaceWith('<div class="addcityswrap myaddress select-wrapper select-wrapper--primary is-filled"><svg focusable="false" class="icon icon--arrow-bottom" viewBox="0 0 12 8" role="graphics-symbol"><path stroke="currentColor" stroke-width="2" d="M10 2L6 6 2 2" fill="none" stroke-linecap="square"></path></svg><select id="city" class="city citydropdown form__field form__field--text" name="address[city]" style="display: inline-block;" required><option value="">Select City</option></select></div>');
            $('.addcityswrap.myaddress').replaceWith('<div class="addcityswrap myaddress select-wrapper select-wrapper--primary is-filled"><svg focusable="false" class="icon icon--arrow-bottom" viewBox="0 0 12 8" role="graphics-symbol"><path stroke="currentColor" stroke-width="2" d="M10 2L6 6 2 2" fill="none" stroke-linecap="square"></path></svg><select id="city" class="city citydropdown form__field form__field--text" name="address[city]" style="display: inline-block;" required><option value="">Select City</option></select></div>');

            $.each(uniqueCity, function(index, val) {
              $('.citydropdown').append('<option value="'+uniqueCity[index]+'">'+uniqueCity[index]+'</option>');
            });

            let stateHtml = [];
            $('.addprovince,.address-state').html('<option value="">Select State</option>');
            $.each(uniqueState, function(index, val) {
              $('.addprovince,.address-state').append('<option value="'+uniqueState[index]+'">'+uniqueState[index]+'</option>');
            });
          }
          else{
          	$('label[for="customer[zipcode]"], label[for*="[zip]"]').after('<div class="match-msg zipcode-error" style="display: block;">Zip code not found</div>');
            $('.customer__address-field .city').replaceWith('<div class="addcityswrap select-wrapper select-wrapper--primary is-filled"><svg focusable="false" class="icon icon--arrow-bottom" viewBox="0 0 12 8" role="graphics-symbol"><path stroke="currentColor" stroke-width="2" d="M10 2L6 6 2 2" fill="none" stroke-linecap="square"></path></svg><select id="city" class="city citydropdown form__field form__field--text" name="customer[city]" style="display: inline-block;" required><option value="">Select City</option></select></div>');
            $('.addcityswrap.myaddress').replaceWith('<div class="addcityswrap myaddress select-wrapper select-wrapper--primary is-filled"><svg focusable="false" class="icon icon--arrow-bottom" viewBox="0 0 12 8" role="graphics-symbol"><path stroke="currentColor" stroke-width="2" d="M10 2L6 6 2 2" fill="none" stroke-linecap="square"></path></svg><select id="city" class="city citydropdown form__field form__field--text" name="address[city]" style="display: inline-block;" required><option value="">Select City</option></select></div>');
            $('.addprovince,.address-state').html('<option value="">Select State</option>');
          }
        },
        headers: { 'token': token },
        dataType: 'json'
      });
    }
    else {
      $('.customer__address-field .city').replaceWith('<div class="addcityswrap select-wrapper select-wrapper--primary is-filled"><svg focusable="false" class="icon icon--arrow-bottom" viewBox="0 0 12 8" role="graphics-symbol"><path stroke="currentColor" stroke-width="2" d="M10 2L6 6 2 2" fill="none" stroke-linecap="square"></path></svg><select id="city" class="city citydropdown form__field form__field--text" name="customer[city]" style="display: inline-block;" required><option value="">Select City</option></select></div>');
      $('.addcityswrap.myaddress').replaceWith('<div class="addcityswrap myaddress select-wrapper select-wrapper--primary is-filled"><svg focusable="false" class="icon icon--arrow-bottom" viewBox="0 0 12 8" role="graphics-symbol"><path stroke="currentColor" stroke-width="2" d="M10 2L6 6 2 2" fill="none" stroke-linecap="square"></path></svg><select id="city" class="city citydropdown form__field form__field--text" name="address[city]" style="display: inline-block;" required><option value="">Select City</option></select></div>');
      $('.addprovince,.address-state').html('<option value="">Select State</option>');
    }
  });
  $('select[name="address[country]"]').val('United States');
});


function sets(){
  $('.sets .add-to-cart-main').on('click',function(){

    let thisBtm = $(this);

    document.dispatchEvent(new CustomEvent('theme:loading:start'));
    let setLength = $(".set_add-to-cart").length;
    
    if(setLength){
      localStorage.setItem("set_products",setLength);

      thisBtm.html('Adding to cart...');
      $('body').append('<div data-v-pset id="setPopup" class="loader-overlay modal quickview-modal visible"><div data-v-pset class="loader-box loader-box modal__content"><strong>Please wait! Products are being added.</strong></div></div>');
      $('html').addClass('freeze-body');
    }

    let setQuery2 =[];

    setTimeout(function(){
      for (let i=0; i < setLength; i++){

            let id = $(".set_products .set_"+i+":not(:disabled)").data('variant');
            let quantity = $(".set_products .set_"+i+":not(:disabled)").data('qty');

            if(id != undefined && quantity != undefined){
              setQuery2.push({
                id,
                quantity
              });
            }
      }

      let chunks = 5;
      let setQuery2Size = setQuery2.length/chunks;
      if((setQuery2.length%chunks) >= 1){
        setQuery2Size = Math.ceil(setQuery2Size);
      }

      function sliceIntoChunks(arr, chunkSize) {
          const res = [];
          for (let i = 0; i < arr.length; i += chunkSize) {
              const chunk = arr.slice(i, i + chunkSize);
              res.push(chunk);
          }
          return res;
      }
      let setChunks = sliceIntoChunks(setQuery2, chunks);
      setChunks.forEach((element,i) => {
        setTimeout(
            function(){
              let formData = {
                'items': element
              };
              fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
              })
              .then(response => {
                //console.log('count i val',i);  
                //console.log('setQuery2Size',setQuery2Size);  
                //console.log('time',i,i * 4000);  
                if(++i == setQuery2Size){
                  document.documentElement.dispatchEvent(new CustomEvent('product:added', {
                      bubbles: true,
                      detail: {
                        quantity: 1
                      }
                    }));
                    document.dispatchEvent(new CustomEvent('theme:loading:end'));
                    thisBtm.html('Add to cart');
                    $('#setPopup').remove();
                    $('html').removeClass('freeze-body');

                }
              })
              .catch((error) => {
                console.error('Error:', error);
              });

            }
        , i * 4000);
      });
    },2000);

  });
}
$(function() {
  setTimeout(
    function(){
      sets();
    }
    ,1000)
});

$(document).ready(function(){
  $('button#verify,button#resend-verify,button#ca-verify,button#ca-resend-verify').click(function(){
    verifyPasscode();
    hideForm();
  });
    $('button#back-verify,button#ca-back-verify').click(function(){
    showForm(false);    
  });
  $('#create_customer input[type="email"]').on('input',function(){
    if($(this).val().length > 0){
      verifyButton();
      $('#create_customer .form__submit.create_account').attr('disabled','disabled');
    }
  });
  $('.form__field--text.pc').on('input',function(){
    if($(this).val().length == 6){
      validatePasscode($(this).val(),$('#create_customer input[type="email"]').val());
    }
  });
  $('.form__field--text.ca-pc').on('input',function(){
    if($(this).val().length == 6){
      validatePasscode($(this).val(),$('#create_customer.ca input[type="email"]').val());
    }
  });
  function verifyButton(){
    $('button#verify,button#ca-verify').removeClass('f--hidden');   
  }
});

function showForm(e){
  $('.form__input-wrapper, .customer-registration, .form__submit').removeClass('f--hidden');
  $('.form__input-wrapper.verify-passcode').removeClass('f--show');
  $('.form__input-wrapper.verify-passcode').addClass('f--hidden');

  $('.ca .form__input-wrapper, .ca .customer-registration, .ca  .form__submit').removeClass('f--hidden');
  $('.form__input-wrapper.ca-verify-passcode').removeClass('f--show');
  $('.form__input-wrapper.ca-verify-passcode').addClass('f--hidden');
  if(e){
    $('button#verify').addClass('f--hidden');
    $('button#verify').removeClass('f--show');
    $('button#ca-verify').addClass('f--hidden');
    $('button#ca-verify').removeClass('f--show');
  }
}

function hideForm(){
  $('.form__input-wrapper, .customer-registration, .form__submit').addClass('f--hidden');
  $('.form__input-wrapper.verify-passcode').addClass('f--show');

    $('.ca .form__input-wrapper, .ca .customer-registration, .ca .form__submit').addClass('f--hidden');
    $('.form__input-wrapper.ca-verify-passcode').addClass('f--show');


}

async function verifyPasscode(){
  $('input#pc').val('');
  const customerEmail= $('#create_customer input[type="email"]').val();
  const customerEmailCA= $('#create_customer.ca input[type="email"]').val();
  try {
    if(customerEmail.length > 0){
      const path = `otp/generate`;
      const body={"email": customerEmail};
      const data=await makeRequest("POST",path,body);
      if (data.status == true && data.status) 
      {
          $('#create_customer .form__submit').removeAttr('disabled');
      }
      else{
          $('#create_customer .form__submit.create_account').attr('disabled', 'disabled');
      }
    }
    else if(customerEmailCA.length > 0){
      const path = `otp/generate`;
      const body={"email": customerEmailCA};
      const data=await makeRequest("POST",path,body);
      if (data.status == true && data.status) 
      {
          $('#create_customer.ca .form__submit').removeAttr('disabled');
      }
      else{
          $('#create_customer.ca .form__submit.create_account').attr('disabled', 'disabled');
      }
    }
  } catch (error) {
    console.log(error);
  }
}

async function validatePasscode(pc,email){
  try{
    
    if(pc != null){

      const path = `otp/validate`;
      const body={"email": email,"otp": pc};
      const data=await makeRequest("POST",path,body);
      if (data.status == true && data.status && data.msg == "OTP valid" && data.verificationCode != null) {
        showForm(true);
        $('input#vc').val(",vc:"+data.verificationCode);
      } 
      else{
          $('.pcMsg').html(data.msg);
      }
            
      
    }
    
  } catch (error) {
    console.log(error);
  }
  
}

async function makeRequest(method,path,reqPayload){
  const baseUrl = 'https://macshopify-us-staging.sbd-nonprod.com/api'
  const accessToken = '893ca8ee-63cf-4ad8-afa7-d063fec127f6'
  const url=`${baseUrl}/${path}`
  const reqMeta={
    method: method,
    headers: {
      'Content-Type': 'application/json',
      "Accept": "application/json",
      "token": accessToken
      }
    }
    if(reqPayload){
      reqMeta["body"]=JSON.stringify(reqPayload)
    }
    const response = await fetch(url,reqMeta);
    const data = await response.json();
    return data;
}

  


